import { type Language, LANGUAGES, ROUTES } from "./config/routes.js";
import { isUserConnected } from "./global/index.js";
import { openIntercomOnClick } from "./pages/multi-page/open-intercom-on-click.js";
import { checkDOMReadyState } from "./utils/dom-readystate-checker.js";
import { observeFramerNavigation } from "./utils/framer-spa-observer.js";

const normalizePath = (path: string): { path: string; lang: Language } => {
  const matchedLang = LANGUAGES.find(
    (lang) => lang !== "en" && (path === `/${lang}` || path.startsWith(`/${lang}/`))
  );

  if (matchedLang) {
    const cleanPath = path.replace(`/${matchedLang}`, "") || "/";
    return { path: cleanPath, lang: matchedLang };
  }

  return { path, lang: "en" };
};

const initializedRoutes = new Set<string>();

const loadPageScripts = async () => {
  const { path: currentPath } = normalizePath(window.location.pathname);

  const routeKey = Object.entries(ROUTES).find(([_, paths]) => {
    return paths.some((path) => currentPath === path);
  })?.[0] as keyof typeof ROUTES | undefined;

  if (!routeKey || initializedRoutes.has(routeKey)) return;
  initializedRoutes.add(routeKey);

  const modulePath = `./pages/${routeKey.replace(/[A-Z]/g, (letter) => "-" + letter.toLowerCase())}/index.js`;
  try {
    const module = await import(modulePath);
    if (typeof module.default === "function") module.default();

    Object.entries(module).forEach(([name, fn]) => {
      if (name !== "default" && typeof fn === "function") {
        fn();
      }
    });
  } catch (err) {
    console.log("no script to load dynamically for pages", err);
  }
};

checkDOMReadyState(() => {
  openIntercomOnClick();
  loadPageScripts();
  observeFramerNavigation(loadPageScripts, "[data-framer-name]");
});

(window as any).isUserConnected = isUserConnected;
